<template>
    <section class="section-membership-jumbo" :class="color">
        <div class="relative isolate overflow-hidden">
            <ImageJumbo
                class="-z-20"
                :image="$config.public.images + 'aaa-jumbo.jpg'"
                imageAlt="andy guitar show reel"
                imagePosition="object-center"
                imageOpacity="opacity-10"
                :imageLoading="imageLoading"
                :fetchPriority="fetchPriority"
            ></ImageJumbo>
            <LayoutContained :class="innerClasses" class="z-0">
                <div class="text-center text-white" v-if="!selectedPlan">
                    <h1 class="mb-3 text-xl font-medium uppercase">
                        {{ product.subscription_product_name }}
                    </h1>
                    <h2 class="mb-3 text-2xl font-medium tracking-tight md:text-5xl" v-if="freeTrialAvailable">
                        Free Trial. First {{ product.subscription_product_trial_length }}
                        <span class="capitalize">{{ product.subscription_product_trial_interval }}</span><span v-if="product.subscription_product_trial_length !== 1">s</span>
                        Free.
                    </h2>
                    <h2 class="mb-3 text-base md:text-2xl">
                        Choose your plan. Cancel anytime.
                    </h2>
                    <div class="inline-flex flex-row items-center space-x-2 text-lg">
                        <IconCheckBadge></IconCheckBadge>
                        <div class="text-sm md:text-lg">
                            60 Day Money-Back Guarantee
                        </div>
                    </div>
                </div>
                <div class="mx-auto grid max-w-xl grid-cols-1 gap-8" v-if="selectedPlan">
                    <slot name="checkout"></slot>
                </div>
                <div class="mx-auto mt-10 grid max-w-3xl grid-cols-1 gap-8 lg:grid-cols-2" v-else>
                    <LayoutPlan
                        v-for="plan in plans"
                        :key="'plan-' + plan.id_subscription_plan"
                        :plan="plan"
                        :plans="plans"
                        @selectPlan="selectPlan"
                    ></LayoutPlan>
                </div>
            </LayoutContained>
        </div>
    </section>
</template>

<script>
export default {
    name: 'SectionMembershipJumbo',
    props: {
        product: {
            required: true,
            type: Object,
            default () {
                return {};
            },
        },
        selectedPlan: {
            required: false,
            type: Object,
            default () {
                return {};
            },
        },
        selectPlan: {
            required: false,
            type: Function,
            default: () => {},
        },
        padding: {
            required: false,
            default: 'py-10 sm:py-12',
            type: String,
        },
        color: {
            required: false,
            type: String,
            default: 'bg-zinc-900',
        },
        imageLoading: {
            required: false,
            type: String,
            default: undefined,
        },
        fetchPriority: {
            required: false,
            type: [String, undefined],
            default: undefined,
        },
    },
    computed: {
        innerClasses () {
            const cls = {};
            cls[this.padding] = true;
            return cls;
        },
        plans () {
            return this.product.subscription_plans;
        },
        freeTrialAvailable () {
            return (this.product.subscription_product_trial_interval && this.product.subscription_product_trial_length);
        },
    },
};
</script>
